import { render } from "./SharePopup.vue?vue&type=template&id=56fc48b0&scoped=true&ts=true"
import script from "./SharePopup.vue?vue&type=script&lang=ts"
export * from "./SharePopup.vue?vue&type=script&lang=ts"

import "./SharePopup.vue?vue&type=style&index=0&id=56fc48b0&scoped=true&lang=css"

import exportComponent from "/Users/alcyone/Desktop/front/chapito-static/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56fc48b0"]])

export default __exports__